import { useEffect, useState, useCallback } from "react";
import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import CustomizeMeal from "../../components/dashboard/dashboardPartials/CustomizeMeal";
import { useGeneral } from "../../components/contexts/GeneralContext";
import axios from "../../config/axios";
import { useToast } from "../../components/contexts/ToastContext";
import { useParams } from "react-router-dom";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";

const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { id } = useParams();

  const fetchContent = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/dashboard/meal-selection/${id}`);
      setContent(data);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load plans. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return { content, loading, error, discountCoupons, id, fetchContent };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const MealCustomization = () => {
  const { content, loading, error, id, discountCoupons, fetchContent } =
    usePageContent();
  const { addToast } = useToast();
  useScrollToTop();

  const [activeWeek, setActiveWeek] = useState(1);
  const [loading2, setLoading2] = useState(false);

  // -------------------- Post Customization --------------------
  const handleSubmitCustomization = async (date, mealType, value) => {
    //console.log(date, mealType, value, " in main fn ");
    setLoading2(true);

    try {
      const payload = {
        date,
        mealId: mealType,
        foodId: value,
        subscriptionId: id,
      };

      const { data } = await axios.post("/dashboard/meal-selection", payload);
      //console.log("Customization saved successfully:", data);
      addToast("Your meal customization has been saved!", "success");

      // 🔄 Refetch latest meal data after saving
      await fetchContent();
    } catch (error) {
      console.error("Error saving customization:", error);
      addToast("Failed to save your customization. Please try again.", "error");
    } finally {
      setLoading2(false);
    }
  };

  return (
    <PageWrapper loading={loading} className="bg-bg min-h-screen">
      <Header code={discountCoupons} />
      {loading && <FullScreenLoading />}

      <BodyWrapper className="lg:mb-0">
        <Wrapper goBack={true}
          component={
            !loading && error ? (
              <ApiErrorMessage
                message1="Failed to load content"
                message2="Please check your connection and try again."
              />
            ) : !loading && !content ? (
              <NoItemsFound
                message1="Subscription details unavailable"
                message2="Please check back later."
              />
            ) : (
              content && (
                <CustomizeMeal
                  meal={content}
                  loading={loading2}
                  activeWeek={activeWeek}
                  setActiveWeek={setActiveWeek}
                  onUpdateMeals={handleSubmitCustomization}
                />
              )
            )
          }
        />
      </BodyWrapper>

      <Footer />
    </PageWrapper>
  );
};

export default MealCustomization;
